<div class="picker-columns">
  <div class="picker-above-highlight"></div>
  <div class="picker-highlight"></div>
  <ng-container *ngFor="let pickerColumn of columns">
    <app-picker-column [column]="pickerColumn" (columnChange)="onHandleColumnChange(pickerColumn)"></app-picker-column>
  </ng-container>
  <div class="picker-below-highlight"></div>
</div>
